import { render, staticRenderFns } from "./si_ticketColorful.vue?vue&type=template&id=6c650680&scoped=true&"
import script from "./si_ticketColorful.vue?vue&type=script&lang=js&"
export * from "./si_ticketColorful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c650680",
  null
  
)

export default component.exports